import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=910c798c"
import script from "./teachers.vue?vue&type=script&lang=js"
export * from "./teachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports